import { conversionBooleanoJson, conversionFechaJson, conversionNumberJson, conversionStringJson, convertirFechaFirebase } from "./utiles_objetos";

export class Cliente{
    constructor({
        carrera = "",
        universidad = "",
        nombreCliente = "",
        numero = 0,
        nombrecompletoCliente = "",
        procedencia = "",
        fechaContacto = new Date(),
        ultimaModificacion = 0,
        campanaRealizada = "",
        
        contextoCliente = "",
        correoElectronico = "",
        permitidoNotificacionesWachat = false,

        infoPlataforma = null,
        clienteEspecialPlataformaUNAD = false,

        //estado del cliente
        estadoClienteEspecial = "", //COTIZANDO, COTIZACION_PASADA //CONTACTO_CLIENTE //NO_ACCESO_PLATAFORMA //COTIZACION_LISTA

        cuentasClientes = [],

        //nuevos
        nombre = "",
        apellido = "",
        noCalificado = false,

        //nuevos de campaña, puestos por campaña
        SourceUrl = "",
        SourceId = "",
        SourceType = "",
        Ctwa_clid = "", //ultimo 

        estadoTrabajoUnadCurso = "",

        AtribucionAnuncio = new Date(),

        //de servidor
        estadisticasCliente = {},

        //ID PARA SEGURIDAD
        publicId = "",

        //rol
        rol = "CLIENTE",

        //NUEVOS
        //guardar historial de ctwa clid?
        

    } = {} ) {
        this.carrera = carrera;
        this.universidad = universidad;
        this.nombreCliente = nombreCliente;
        this.numero = numero;
        this.nombrecompletoCliente = nombrecompletoCliente;
        this.procedencia = procedencia;
        this.fechaContacto = fechaContacto;
        this.ultimaModificacion = ultimaModificacion;
        this.campanaRealizada = campanaRealizada;
        this.contextoCliente = contextoCliente;
        this.correoElectronico = correoElectronico;
        this.permitidoNotificacionesWachat = permitidoNotificacionesWachat;
        this.infoPlataforma = infoPlataforma;
        this.clienteEspecialPlataformaUNAD = clienteEspecialPlataformaUNAD;
        this.cuentasClientes = cuentasClientes;
        this.estadoClienteEspecial = estadoClienteEspecial;
        this.nombre = nombre;
        this.apellido = apellido;
        this.noCalificado = noCalificado;

        //aultomaticos, que vienen 
        this.SourceUrl = SourceUrl;
        this.SourceId = SourceId;
        this.SourceType = SourceType;
        this.Ctwa_clid = Ctwa_clid;

        this.estadoTrabajoUnadCurso = estadoTrabajoUnadCurso;

        this.AtribucionAnuncio = AtribucionAnuncio;

        this.estadisticasCliente = estadisticasCliente;

        this.publicId = publicId;
        this.rol = rol;
    };

    static fromJson (json){

        console.log("cliente obtenido",json);

        const fechaContactoLocal = convertirFechaFirebase(json['fechaContacto']);
        const AtribucionAnuncioLocal = convertirFechaFirebase(json['AtribucionAnuncio']);
        const universidad = json['Universidadd'] || json['universidad'] || '';
        
        return new Cliente({
            carrera: json['Carrera'] || "NO REGISTRADO",
            universidad: universidad,
            nombreCliente : json['nombreCliente'] || "",
            numero: json['numero'] || 0,
            nombrecompletoCliente: json['nombrecompletoCliente'] || '',
            procedencia: json['procedencia'] || '',
            fechaContacto: fechaContactoLocal,
            ultimaModificacion: json['ultimaModificacion'] || 0,
            campanaRealizada: json['campanaRealizada'] || '',
            contextoCliente: json['contextoCliente'] || '',
            correoElectronico: json['correoElectronico'] || '',
            permitidoNotificacionesWachat: json['permitidoNotificacionesWachat'] ?? true,
            infoPlataforma: json.infoPlataforma ?? {},
            //se tiene
            //plataforma
            //usuario
            //contrasena
            clienteEspecialPlataformaUNAD: json['clienteEspecialPlataformaUNAD'] || false,
            cuentasClientes: json.cuentasClientes ?? '',
            estadoClienteEspecial: json['estadoClienteEspecial'] || 'CONTACTO_CLIENTE',
            nombre: json['nombre'] || '',
            apellido: json['apellido'] || '',
            noCalificado: json['noCalificado'] || false,

            //AUTOMATIOCO
            SourceUrl: json['SourceUrl'] || '',
            SourceId: json['SourceId'] || '',
            SourceType: json['SourceType'] || '',
            Ctwa_clid: json['Ctwa_clid'] || '',

            estadoTrabajoUnadCurso: json['estadoTrabajoUnadCurso'] || '',

            AtribucionAnuncio: AtribucionAnuncioLocal,

            estadisticasCliente: json.estadisticasCliente,

            publicId: json['publicId'] || '',
            rol: json['rol'] || 'CLIENTE',
        });
    }

    toMap(){
        return{
            'Carrera': conversionStringJson(this.carrera),
            'Universidadd': conversionStringJson(this.universidad),
            'nombreCliente': conversionStringJson(this.nombreCliente),
            'numero': conversionNumberJson(this.numero),
            'nombrecompletoCliente': conversionStringJson(this.nombrecompletoCliente),
            'procedencia' : conversionStringJson(this.procedencia),
            'fechaContacto' : conversionFechaJson(this.fechaContacto),
            'ultimaModificacion' : conversionNumberJson(this.ultimaModificacion),
            'campanaRealizada' : conversionStringJson(this.campanaRealizada),
            'contextoCliente' : conversionStringJson(this.contextoCliente),
            'correoElectronico' : conversionStringJson(this.correoElectronico),
            'permitidoNotificacionesWachat' : conversionBooleanoJson(this.permitidoNotificacionesWachat),
            'clienteEspecialPlataformaUNAD' : this.clienteEspecialPlataformaUNAD,
            'nombre' : this.nombre,
            'apellido' : this.apellido,
            'noCalificado' : this.noCalificado,
        }
    }

    //actualizacion rapida
    toActualizarRapido(){
        return{
            'Carrera': this.carrera,
            'Universidadd': this.universidad,
            'nombreCliente': this.nombreCliente,
            'numero': this.numero,
            'nombrecompletoCliente': this.nombrecompletoCliente,
            'nombre' : this.nombre,
            'apellido' : this.apellido,
            'correoElectronico' : conversionStringJson(this.correoElectronico),
            'noCalificado' : true,
        }
    }

}

export class CuentasClientes{
    constructor({
        usuario = "",
        contrasena = "",
        plataforma = "",
    } = {}){
        this.usuario = usuario;
        this.contrasena = contrasena;
        this.plataforma = plataforma;
    }

    static fromJson(json){

        return new CuentasClientes({
            usuario: json['usuario'] || "",
            contrasena: json['contrasena'] || "",
            plataforma: json['plataforma'] || "",
        });

    }

    toMap(){

    }
}